const groupFinTermsEditActions = {
  GROUP_FIN_TERMS_EDIT_INIT: 'GROUP_FIN_TERMS_EDIT_INIT',
  GROUP_FIN_TERMS_EDIT_SET: 'GROUP_FIN_TERMS_EDIT_SET',
  GROUP_FIN_TERMS_PROP_SET: 'GROUP_FIN_TERMS_PROP_SET',
  GROUP_FIN_TERMS_GATE_PARAM_SET: 'GROUP_FIN_TERMS_GATE_PARAM_SET'
};
export default groupFinTermsEditActions;
